<template>
	<div class="animate__animated animate__fadeIn" data-wow-duration="0.8s">
		<!-- 路由导航 -->
		<div class="routerDh f-bct">
			<div class="l f-ct">
				<div class="t1">当前位置：</div>
				<!-- 课程中心
				<el-image :src="require('@/static/icon55.png')"></el-image>
				<div class="t1">课程详情</div>
				<el-image :src="require('@/static/icon55.png')"></el-image> -->
				<div class="t2">订单详情</div>
			</div>
			<div class="r f-ct" @click="back()">
				<div class="t2">返回上一页</div>
				<el-image :src="require('@/static/icon56.png')"></el-image>
			</div>
		</div>
		<!-- 内容 -->
		<div class="pageCon">
			<div class="bor"></div>
			<!-- 订单状态 -->
			<div class="statusBox">
				<div class="tit f-bct">
					<div class="titl f-ct">
						<el-image :src="require('@/static/icon62.png')"></el-image>
						<p>已缴费</p>
					</div>
					<!-- 普通 -->
					<div class="titr" v-if="userType==1">您需要支付：<span>￥{{pageMsg.price}}</span></div>
					<!-- 企业 -->
					<div class="titr" v-if="userType==2">缴费总金额：<span>￥{{pageMsg.totalPrice}}</span></div>
				</div>
				<div class="t1">
					报名课程：<span>{{pageMsg.courseName}}</span>
				</div>
				<div class="t2">
					报名时间：<span>{{pageMsg.createTime}}</span>
				</div>
				
				<!-- 普通 -->
				<div class="t2">
					订单编号：<span>{{pageMsg.orderNo}}</span>
				</div>
				<!-- 企业 -->
				<div class="t2" v-if="userType==2">
					报名人数：<span>{{pageMsg.courseOrderList.length}}</span>
				</div>
				
			</div>
			<!-- 报名人数 企业 -->
			<div class="manTable" v-if="userType==2">
				<div class="tit f-ct">
					<el-image :src="require('@/static/icon91.png')"></el-image>
					报名人数(4)
				</div>
				<div class="kfpTableBox">
				<div class="kfpTable">
					<div class="th f-ct">
						<div class="t1">序号</div>
						<div class="t2">姓名</div>
						<div class="t3">性别</div>
						<div class="t4">身份证号码</div>
						<div class="t5">联系方式</div>
						<div class="t6">报名费用</div>
					</div>
					<div class="td f-ct" v-for="(item,index) in pageMsg.courseOrderList">
						<div class="t1">{{item.memberId}}</div>
						<div class="t2">{{item.memberName}}</div>
						<div class="t3" v-if="item.memberGender==0">未知</div>
						<div class="t3" v-if="item.memberGender==1">男</div>
						<div class="t3" v-if="item.memberGender==2">女</div>
						<div class="t4">{{item.memberIdentityCardCode}}</div>
						<div class="t5">{{item.memberMobile}}</div>
						<div class="t6">￥{{item.price}}</div>
					</div>
				</div>
				</div>
			</div>
		</div>
		<!-- 弹出框 -->
		<div class="maskBg" @click="hbSelMan=false" v-if="hbSelMan"></div>
		<div class="subTips" v-if="hbSelMan">
			<div class="hbTit f-bct">
				<p>选择开票信息</p>
				<el-image class="cha" @click="hbSelMan=false" :src="require('@/static/icon57.png')"></el-image>
			</div>
			<div class="Tab">
				<div class="th f-ct">
					<p class="t1">选择</p>
					<p class="t2">开票类型</p>
					<p class="t3">单位名称</p>
					<p class="t4">纳税人识别号</p>
					<p class="t5">姓名</p>
					<p class="t6">接收邮箱</p>
				</div>
				<div class="tdBox">
					<div class="td f-ct" v-for="(item,index) in kpxxList">
						<div class="t1" @click="kpxxId=item.id,kpxxItemBf=item">
							<el-image v-if="kpxxId==item.id" :src="require('@/static/icon61.png')"></el-image>
							<el-image v-else :src="require('@/static/icon60.png')"></el-image>
						</div>
						<div class="t2" v-if="item.invoiceType==1">普通发票(个人)</div>
						<div class="t2" v-if="item.invoiceType==2">普通发票(单位)</div>
						<div class="t2" v-if="item.invoiceType==3">专用发票(单位)</div>
						
						<div class="t3" v-if="item.invoiceType==3">{{item.name}}</div>
						<div class="t3" v-if="item.invoiceType!=3">/</div>
						
						<div class="t4" v-if="item.invoiceType!=1">{{item.code}}</div>
						<div class="t4" v-if="item.invoiceType==1">/</div>
						<div class="t5" v-if="item.invoiceType==1">{{item.name}}</div>
						<div class="t5" v-else>/</div>
						<div class="t6" v-if="item.invoiceType!=3">{{item.email}}</div>
						<div class="t6" v-if="item.invoiceType==3">/</div>
					</div>
				</div>
			</div>
			<div class="fenye">
			<el-pagination
			background
			hide-on-single-page
			layout="prev, pager, next,jumper"
			@current-change="goPage"
			:page-size="pageSize"
			:total="total">
			</el-pagination>
			</div>
			<div class="hbbtnBox f-ct">
				<div class="b1" @click="hbSelMan=false">返回</div>
				<div class="b2" @click="courseOrderUpdateOrderInvoice">确认选择</div>
			</div>
		</div>
		<!-- 取消报名 -->
		<div class="maskBg" @click="hbQx=false" v-if="hbQx"></div>
		<div class="subTipsQx" v-if="hbQx">
			<el-image class="cha" @click="hbQx=false" :src="require('@/static/icon57.png')"></el-image>
			<el-image class="icon" :src="require('@/static/icon58.png')"></el-image>
			<div class="t1">取消报名</div>
			<div class="t2">确定取消报名培训课程【{{pageMsg.courseName}}】吗</div>
			<div class="btnBox f-ct">
				<div class="b1" @click="hbQx=false">我再想想</div>
				<div class="b2" @click="courseOrderCancel">确定取消</div>
			</div>
		</div>
		<!-- 取消成功 -->
		<div class="maskBg" @click="hbQxScussF" v-if="hbQxScuss"></div>
		<div class="subTipsQx" v-if="hbQxScuss">
			<el-image class="cha" @click="hbQxScuss=false,back()" :src="require('@/static/icon57.png')"></el-image>
			<el-image class="icon1" :src="require('@/static/icon71.png')"></el-image>
			<div class="t3">课程取消成功</div>
		</div>
		<!-- 取消成功 -->
		<div class="maskBg" v-show="wxPay"></div>
		<div class="subTipsQx" v-show="wxPay">
			<div class="f-ct" style="justify-content: center;">
				<div class="qrcode" ref="qrCodeUrl"></div>
			</div>
			<div class="t1">微信支付</div>
			<div class="t2">请扫描二维码支付</div>
			<div class="btnBox f-ct">
				<div class="b1" @click="wxPay=false">我再想想</div>
				<div class="b2" @click="pdIsPay">我已支付</div>
			</div>
		</div>
		<!-- 结束 -->
		
	</div>
</template>
<script>
import { courseOrderdetail,courseOrderCancel,
courseOrderorderorderCancel,
memberInvoiceList,
courseOrderUpdateOrderInvoice,
wxPaypcScanQRPay,
courseOrdertestPay,
courseOrderorderDetail,
memberInvoiceListQY,
courseOrderupdateOrderInvoice,
courseOrdertestPayOrder
} from "/src/api/api.js"
import QRCode from 'qrcodejs2'
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			id:0,
			hbQx:false,
			hbQxScuss:false,
			hbSelMan:false,
			wxPay:false,
			pageMsg:'',
			// 支付类型
			payType:1,
			// 是否开票
			isKp:0,
			// 开票信息
			kpxxList:[],
			kpxxItemBf:'',
			kpxxItem:'',
			kpxxId:0,
			// 分页
			pageNum:1,
			pageSize:10,
			total:0,
		}
	},
	mounted() {
		// 获取浏览路径
		if (localStorage.getItem('pageHistory')) {
			var arr = localStorage.getItem('pageHistory')
			arr = JSON.parse(arr)
			this.pageHistory = arr
		}
		// 参数
		this.id = this.$route.query.id
		// 获取信息
		this.courseOrderdetail()
		this.memberInvoiceList()
	},
	methods:{
		// 去支付 立即缴费
		async goPaySubmit(){
			// 测试支付
			this.courseOrdertestPay()
			return
			// ********* //
			if(this.payType==1){
				// 微信支付
				let res = await wxPaypcScanQRPay({orderId:this.id});
				if(res.code==200){
					this.creatQrCode(res.msg)
					this.wxPay = true
				}else{this.Tips(res.msg,'error')}
			}
			if(this.payType==2){
				// 支付宝支付
				var str = this.apiUrl+'/app/aliPay/pcPay?orderId='+this.id
				window.location=str;
			}
		},
		// 测试用支付
		async courseOrdertestPay(){
			let res;
			if(this.userType==1){
				res = await courseOrdertestPay({id:this.id});
			}
			if(this.userType==2){
				res = await courseOrdertestPayOrder({companyOrderId:this.id});
			}
			if(res.code==200){
				this.creatQrCode(res.msg)
				this.wxPay = true
			}else{this.Tips(res.msg,'error')}
		},
		// 生成二维码
		creatQrCode(text) {
			var qrcode = new QRCode(this.$refs.qrCodeUrl, {
				text: text, // 需要转换为二维码的内容
				width: 160,
				height: 160,
				colorDark: '#000000',
				colorLight: '#ffffff',
				correctLevel: QRCode.CorrectLevel.H
			})
		},
		// 判断是否支付
		async pdIsPay(){
			if(this.userType==1){
				let res = await courseOrderdetail({id:this.id});
				if(res.code==200){
					if(res.data.orderStatus==2){
						this.link('/userCoursePaySuss',{id:this.id})
					}
				}else{this.Tips(res.msg,'error')}
			}
			if(this.userType==2){
				let res = await courseOrderorderDetail({companyOrderId:this.id});
				if(res.code==200){
					if(res.data.payStatus){
						this.link('/userCoursePaySuss',{id:this.id})
					}
				}else{this.Tips(res.msg,'error')}
			}
		},
		// 更新订单发票信息
		async courseOrderUpdateOrderInvoice(){
			if(!this.kpxxId){this.Tips('请选择开票信息','error');return}
			let res;
			
			if(this.userType==1){
				res = await courseOrderUpdateOrderInvoice({
					memberInvoiceId: this.kpxxId,
					orderId: this.id,
				});
			}
			if(this.userType==2){
				res = await courseOrderupdateOrderInvoice({
					companyInvoiceId: this.kpxxId,
					companyOrderId: this.id,
				});
			}
			if(res.code==200){
				this.Tips(res.msg,'success')
				this.hbSelMan = false
				this.kpxxItem = this.kpxxItemBf
			}else{this.Tips(res.msg,'error')}
		},
		// 获取开票信息 列表
		async memberInvoiceList(def){
			if(def){this.pageNum = 1}
			var data = {
				pageSize: this.pageSize,
				pageNum: this.pageNum,
			}
			let res;
			if(this.userType==1){
				res = await memberInvoiceList(data);
			}
			if(this.userType==2){
				res = await memberInvoiceListQY(data);
			}
			if(res.code==200){
				if(this.pageNum==1){
					this.total = res.total
				}
				this.kpxxList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 打开开票信息弹出框
		openKpxx(){
			if(this.kpxxList.length){
				this.hbSelMan = true
			}else{
				this.link('/userMsg')
			}
		},
		// 跳转页
		goPage(e){
			this.memberInvoiceList()
		},
		// 取消订单 课程
		async courseOrderCancel(){
			let res;
			if(this.userType==1){
				res = await courseOrderCancel({orderId:this.id});
			}
			if(this.userType==2){
				res = await courseOrderorderorderCancel({companyOrderId:this.id});
			}
			if(res.code==200){
				this.hbQx = false
				this.hbQxScuss = true
			}else{this.Tips(res.msg,'error')}
		},
		hbQxScussF(){
			this.hbQxScuss=false
			if(this.pageHistory[this.pageHistory.length-1]=='/userCourseFrom'){
				this.$router.go(-2)
			}else{
				this.back()
			}
		},
		// 获取订单详情
		async courseOrderdetail(){
			let res;
			if(this.userType==1){
				res = await courseOrderdetail({id:this.id});
			}
			if(this.userType==2){
				res = await courseOrderorderDetail({companyOrderId:this.id});
			}
			if(res.code==200){
				let createTime = new Date(res.data.createTime).getTime() + 24 * 60 * 60 * 1000;   //24小时 * 60分钟 * 60秒 * 1000
				res.data.endTime = this.gsTime(createTime)
				this.pageMsg = res.data
			}else{this.Tips(res.msg,'error')}
		},
	},
	computed:{
		...mapState('userMsg',['userInfo','userType']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.qrcode{
    display: inline-block;
	margin-top: 60px;
    img {
        width: 162px;
        height: 162px;
        background-color: #fff; //设置白色背景色
        padding: 6px; // 利用padding的特性，挤出白边
        box-sizing: border-box;
		margin: auto;
    }
}
.routerDh{
	margin: 0 40px;
	margin-bottom: 24px;
	.l{
		.t1{
			font-size: 16px;
			color: #9A9DA7;
			cursor: pointer;
		}
		.el-image{
			width: 16px;
			height: 16px;
			margin: 0 2px;
		}
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
	}
	.r{
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
		.el-image{
			width: 18px;
			height: 18px;
			margin-left: 6px;
		}
	}
}
.pageCon{
	background: #fff;
	margin: 0 40px;
	border-radius: 20px;
	padding: 0 24px;
	padding-top: 24px;
	padding-bottom: 41px;
	.bor{
		width: 1526px;
		height: 10px;
		background: #3B6492;
	}
	.statusBox{
		width: 100%;
		// height: 200px;
		background: #FBFCFF;
		padding: 0 24px;
		padding-top: 32px;
		padding-bottom: 24px;
		.tit{
			padding-bottom: 18px;
			.titl{
				.el-image{
					width: 42px;
					height: 42px;
					margin-right: 16px;
				}
				p{
					font-size: 24px;
					color: #373D50;
					font-weight: bold;
				}
			}
			.titr{
				font-size: 20px;
				// font-weight: bold;
				color: #2F3541;
				span{
					color: #FF5F5A;
				}
			}
		}
		.t1{
			color: #9A9DA7;
			font-size: 16px;
			padding-left: 58px;
			span{
				color: #3B6492;
			}
		}
		.t2{
			padding-left: 58px;
			margin-top: 10px;
			color: #9A9DA7;
			font-size: 16px;
			span{
				color: #2F3541;
			}
		}
	}
	.payTypeTit{
		width: 1526px;
		height: 60px;
		margin-top: 24px;
		padding: 0 22px;
		background: #FBFCFF;
		border: 1px solid #EFF1F6;
		.el-image{
			width: 22px;
			height: 22px;
			margin-right: 10px;
		}
		.t1{
			font-size: 16px;
			font-weight: bold;
			color: #545964;
		}
		.t2{
			font-size: 14px;
			color: #FF5F5A;
			margin-left: 15px;
		}
	}
	.payType{
		border: 1px solid #EFF1F6;
		border-top: none;
		padding: 24px;
		.a{
			border: 2px solid #3B6492!important;
		}
		.itm{
			width: 196px;
			height: 70px;
			border: 1px solid #EFF1F6;
			display: flex;
			align-items: center;
			justify-content: center;
			position: relative;
			border-radius: 4px;
			margin-right: 15px;
			cursor: pointer;
			.icon{
				width: 44px;
				height: 44px;
				margin-right: 14px;
			}
			.t1{
				font-size: 18px;
				color: #2F3541;
			}
			.sel{
				position: absolute;
				bottom: 0;
				right: 0;
				width: 31px;
				height: 24px;
			}
		}
	}
	.kfp{
		width: 1526px;
		height: 60px;
		margin-top: 24px;
		border: 1px solid #EFF1F6;
		background: #FBFCFF;
		padding: 0 22px;
		.tit{
			margin-right: 32px;
			.el-image{
				width: 22px;
				height: 22px;
				margin-right: 10px;
			}
			.t1{
				font-size: 16px;
				color: #545964;
			}
		}
		.selItm{
			margin-right: 20px;
			cursor: pointer;
			.el-image{
				width: 20px;
				height: 20px;
				margin-right: 6px;
			}
			.t1{
				font-size: 16px;
				color: #2F3541;
			}
		}
	}
	.fapiao{
		border: 1px solid #EFF1F6;
		padding-top: 16px;
		border-top: 0;
		padding: 0 24px;
		padding-bottom: 24px;
		.selMan{
			margin-top: 16px;
			.tit{
				font-size: 16px;
				color: #4B5060;
			}
			.msg{
				width: 450px;
				height: 50px;
				border: 2px solid #3B6492;
				border-radius: 4px;
				padding: 0 24px;
				p{
					font-size: 16px;
				}
				.el-image{
					width: 24px;
					height: 24px;
				}
			}
			.detail{
				width: 450px;
				border: 2px solid #EFF1F6;
				padding: 12px 24px;
				margin-left: 84px;
				margin-top: 5px;
				.itm{
					display: flex;
					// align-items: center;
					margin-bottom: 4px;
					.t1{
						width: 110px;
						color: #999AA3;
					}
					.t2{
						width: calc(100% - 110px);
						color: #2F3541;
					}
					p{
						font-size: 14px;
					}
				}
			}
		}
		.selFrom{
			margin-top: 16px;
			.tit{
				font-size: 16px;
				color: #4B5060;
			}
			.a{
				border: 2px solid #3B6492!important;
			}
			.itm{
				width: 155px;
				height: 50px;
				border: 1px solid #EFF1F6;
				display: flex;
				align-items: center;
				justify-content: center;
				position: relative;
				border-radius: 4px;
				margin-right: 15px;
				cursor: pointer;
				.icon{
					width: 44px;
					height: 44px;
					margin-right: 14px;
				}
				.t1{
					font-size: 16px;
					color: #2F3541;
				}
				.sel{
					position: absolute;
					bottom: 0;
					right: 0;
					width: 31px;
					height: 24px;
				}
			}
		}
	}
	.PriceBox{
		width: 1526px;
		height: 100px;
		border: 1px solid #EFF1F6;
		background: #FBFCFF;
		padding-left: 50px;
		padding-right: 50px;
		margin-top: 24px;
		.number{
			font-size: 20px;
			font-weight: bold;
			color: #2F3541;
			span{
				color: #FF5F5A;
			}
		}
		.anniuBox{
			// margin-top: 32px;
			justify-content: flex-end;
			div{
				width: 162px;
				height: 46px;
				border-radius: 6px;
				text-align: center;
				line-height: 46px;
				font-size: 16px;
				cursor: pointer;
			}
			.b1{
				// background: #E9F6FF;
				color: #3B6492;
				text-align: right;
				padding-right: 20px;
			}
			.b2{
				background: #3B6492;
				color: #fff;
				margin-left: 14px;
			}
		}
	}
}
.maskBg{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 10;
}
.subTips{
	position: fixed;
	width: 804px;
	// height: 364px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.hbTit{
		width: 100%;
		height: 69px;
		padding-left: 30px;
		padding-right: 32px;
		background: #FAFBFC;
		border-radius: 8px 8px 0 0;
		p{
			font-size: 18px;
			color: #2F3541;
		}
		.cha{
			width: 14px;
			height: 14px;
		}
	}
	.fenye{
		padding-right: 20px;
	}
	.Tab{
		margin: 0 15px;
		margin-top: 20px;
		margin-bottom: 22px;
		border: 1px solid #EBEEF5;
		.th{
			height: 51px;
			background: linear-gradient(180deg, #F8F9FE 0%, #EDEFF6 81.25%);
			p{
				line-height: 51px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				border-right: 1px solid #EBF0FC;
				font-weight: bold;
				&:last-child{
					border: none;
				}
			}
			.t1{
				width: 50px;
			}
			.t2{
				width: 135px;
			}
			.t3{
				width: 180px;
			}
			.t4{
				width: 170px;
			}
			.t5{
				width: 85px;
			}
			.t6{
				width: 152px;
			}
		}
		.tdBox{
			height: 250px;
			overflow-y: scroll;
		}

		.td{
			border-bottom: 1px solid #EBEEF5;
			align-items: stretch;
			>div{
				text-align: center;
				font-size: 14px;
				color: #333333;
				border-right: 1px solid #EBEEF5;
				padding: 0 10px;
				word-wrap:break-word;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 9px 8px;
				&:last-child{
					border: none;
				}
			}
			.t1{
				width: 50px;
				.el-image{
					width: 18px;
					height: 18px;
					margin: auto;
					display: block;
				}
			}
			.t2{
				width: 135px;
			}
			.t3{
				width: 180px;
			}
			.t4{
				width: 170px;
			}
			.t5{
				width: 85px;
			}
			.t6{
				width: 152px;
			}
		}
	}
	.hbbtnBox{
		margin-top: 28px;
		justify-content: center;
		div{
			width: 162px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b2{
			background: #3B6492;
			color: #fff;
			margin-left: 14px;
		}
	}
}
.manTable{
	border: 1px solid #EFF1F6;
	margin-top: 24px;
	.tit{
		height: 60px;
		padding: 0 22px;
		background: #FBFCFF;
		font-size: 16px;
		color: #545964;
		border-bottom: 1px solid #EFF1F6;
		.el-image{
			width: 22px;
			height: 22px;
			margin-right: 10px;
		}
	}
	.kfpTableBox{
		padding: 24px;
	}
	.kfpTable{
		border: 1px solid #EBEEF5;
		border-bottom: 0;
		// margin-bottom: 40px;
		.th{
			height: 56px;
			// background: linear-gradient(180deg, #F8F9FE 0%, #EDEFF6 81.25%);
			div{
				line-height: 56px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				font-weight: bold;
				display: flex;
				align-items: center;
				justify-content: center;
				border-right: 1px solid #EBEEF5;
				border-bottom: 1px solid #EBEEF5;
			}
			.t1{
				width: 100px;
			}
			.t2{
				width: 200px;
			}
			.t3{
				width: 180px;
			}
			.t4{
				width: 386px;
			}
			.t5{
				width: 386px;
			}
			.t6{
				width: 220px;
			}
		}
		.td{
			border-bottom: 1px solid #EBEEF5;
			align-items: stretch;
			>div{
				line-height: 56px;
				height: 56px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				border-right: 1px solid #EBEEF5;
				padding: 0px 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				&:last-child{
					border: none;
				}
			}
			.t1{
				width: 100px;
			}
			.t2{
				width: 200px;
			}
			.t3{
				width: 180px;
			}
			.t4{
				width: 386px;
			}
			.t5{
				width: 386px;
			}
			.t6{
				width: 220px;
			}
		}
	}
}
.subTipsQx{
	position: fixed;
	width: 420px;
	// height: 364px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.cha{
		position: absolute;
		right: 20px;
		top: 20px;
		width: 14px;
		height: 14px;
	}
	.icon{
		display: block;
		margin: auto;
		margin-top: 48px;
		width: 90px;
		height: 90px;
	}
	.icon1{
		display: block;
		margin: auto;
		margin-top: 48px;
		width: 115px;
		height: 115px;
	}
	.t3{
		font-size: 18px;
		color: #2F3541;
		font-weight: 600;
		text-align: center;
		margin-top: 10px;
	}
	.t1{
		font-size: 18px;
		color: #2F3541;
		font-weight: 600;
		text-align: center;
		margin-top: 25px;
	}
	.t2{
		font-size: 14px;
		color: #7D7D89;
		padding: 0 26px;
		text-align: center;
		margin-top: 12px;
		line-height: 28px;
	}
	.btnBox{
		margin-top: 28px;
		justify-content: center;
		div{
			width: 120px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b2{
			background: #3B6492;
			color: #fff;
			margin-left: 14px;
		}
	}
}
</style>